import GroupPage from './GroupPage';
import GroupPageContainer from './GroupPage.container';

export default GroupPageContainer(GroupPage);
